function UIElementEdit(hs) {
    this.hs = hs;
    this.node = hs.node;    
    this.locked = false;

	var self = this;
    this.playernode = $("#player");
//	this.node.on(Events.pointer.down, function(evt) {var pe = Events.getPointerEvent(evt); self.mouseDown(pe);});
    this.node.on("click", function(evt) {var pe = Events.getPointerEvent(evt); self.click(pe);});

//    this.addSprite();
}

UIElementEdit.prototype.addUI = function() {
    this.mover = $("<div class='elem_mover'></div>");
    this.hs.node.append(this.mover);

    this.rulers = {};

    this.rulers['l'] = $("<div class='hruler'></div>");
    this.rulers['r'] = $("<div class='hruler'></div>");
    this.rulers['t'] = $("<div class='vruler'></div>");
    this.rulers['b'] = $("<div class='vruler'></div>");
    
    this.playernode.append(this.rulers['l']);
    this.playernode.append(this.rulers['r']);
    this.playernode.append(this.rulers['t']);
    this.playernode.append(this.rulers['b']);
    
    var self = this;
    this.mover.on(Events.pointer.down, function(evt) {var pe = Events.getPointerEvent(evt); self.mouseDown(pe);});
    this.update();
}

UIElementEdit.prototype.addSprite = function() {
    var self = this;
}

UIElementEdit.prototype.updateRulers = function() {
    var w = this.playernode.width();// - 20;
    var h = this.playernode.height();// - 20;

    var nw = this.hs.node.width();// - 20;
    var nh = this.hs.node.height();// - 20;
    var w2 = (nw * 0.5);// - 20;
    var h2 = (nh * 0.5);// - 20;

    if (this.rulers != undefined) {
        this.rulers['l'].css("right", (w - this.hs.x) + "px");
        this.rulers['l'].css("top", (this.hs.y + h2) + "px");

        this.rulers['r'].css("left", (this.hs.x + nw) + "px");
        this.rulers['r'].css("top", (this.hs.y + h2) + "px");

        this.rulers['t'].css("left", (this.hs.x + w2) + "px");
        this.rulers['t'].css("bottom", (h - this.hs.y) + "px");

        this.rulers['b'].css("left", (this.hs.x + w2) + "px");
        this.rulers['b'].css("top", (this.hs.y + nh) + "px");

        if (this.hs.x > w * 0.5 - w2) {
            this.hs.params.align = "r";
            this.rulers['l'].css("visibility", "hidden");
            this.rulers['r'].css("visibility", "visible");
        } else if (this.hs.x < w * 0.5 - w2) {
            this.hs.params.align = "l";
            this.rulers['l'].css("visibility", "visible");
            this.rulers['r'].css("visibility", "hidden");
        } else {
            this.hs.params.align = "c";
            this.rulers['l'].css("visibility", "visible");
            this.rulers['r'].css("visibility", "visible");
        }

        if (this.hs.y > h * 0.5 - h2) {
            this.hs.params.valign = "b";
            this.rulers['t'].css("visibility", "hidden");
            this.rulers['b'].css("visibility", "visible");
        } else if (this.hs.y < h * 0.5 - h2) {
            this.hs.params.valign = "t";
            this.rulers['t'].css("visibility", "visible");
            this.rulers['b'].css("visibility", "hidden");
        } else {
            this.hs.params.valign = "m";
            this.rulers['t'].css("visibility", "visible");
            this.rulers['b'].css("visibility", "visible");
        }
    }
}

UIElementEdit.prototype.update = function() {
    var l = (this.hs.node.width() * 0.5);// - 20;
    var t = (this.hs.node.height() * 0.5);// - 20;

    //this.mover.css("left",l);
    //this.mover.css("top",t);

//    this.updateRulers();
}

UIElementEdit.prototype.click = function(event) {
    self = this;

    $(".elem_mover").hide();
    this.mover.show();
    UIEdit.select(this);
}

UIElementEdit.prototype.mouseDown = function(event) {
	this.drag = {};
	this.drag.x = event.pageX;
	this.drag.y = event.pageY;
	this.down = true;
    Cms.root.$refs.uiedit.ghost(true);

    this.lx = this.hs.x;
    this.ly = this.hs.y;

    self = this;
    this.playernode.one(Events.pointer.up, function(evt) {var pe = Events.getPointerEvent(evt); self.mouseUp(pe);});
    this.playernode.on(Events.pointer.move, function(evt) {var pe = Events.getPointerEvent(evt);self.mouseMove(pe);});

    this.node.css("pointer-events", "none");

    this.hs.calculateCoords(this.hs.hpos(), this.hs.vpos())
    this.hs.update();
//    this.hs.updatePosition = false;

    try {
        UIEdit.select(this);
    } catch(e) {

    }

    this.updateRulers();

    event.origin.preventDefault();
}

UIElementEdit.prototype.mouseUp = function(event) {

    self = this;
    //this.manager.player.node.off(Events.pointer.up, function(evt) {var pe = Events.getPointerEvent(evt); self.mouseUp(pe);});
    this.playernode.off(Events.pointer.move, function(evt) {var pe = Events.getPointerEvent(evt);self.mouseMove(pe);});
    this.node.css("pointer-events", "all");
  //  this.hs.updatePosition = true;
    Cms.root.$refs.uiedit.ghost(false);

    if (this.dragging) {
        this.down = false;
    	this.dragging = false;

        var xx = event.pageX - this.drag.x;// + this.node.outerWidth() * 0.5;
        var yy = event.pageY - this.drag.y;// + this.node.outerHeight() * 0.5;

        if (!isNaN(xx)) this.hs.x += xx;
        if (!isNaN(yy)) this.hs.y += yy;

        this.hs.params.screen = {"w": $(document).width(), "h": $(document).height()};

        this.hs.calculateCoords(this.hs.hpos(), this.hs.vpos())
        this.hs.update();

    } else {
        this.down = false;
        this.dragging = false;
    }

    if (this.rulers != undefined) {
        this.rulers['l'].css("visibility", "hidden");
        this.rulers['r'].css("visibility", "hidden");
        this.rulers['t'].css("visibility", "hidden");
        this.rulers['b'].css("visibility", "hidden");
	}

    event.origin.preventDefault();
}

UIElementEdit.prototype.mouseMove = function(event) {
    var w = this.playernode.width();// - 20;
    var h = this.playernode.height();// - 20;

    var nw = this.hs.node.width();// - 20;
    var nh = this.hs.node.height();// - 20;

 	if (this.down) {
        this.dragging = true;
        
        var xx = event.pageX - this.drag.x;// + this.node.outerWidth() * 0.5;
        var yy = event.pageY - this.drag.y;// + this.node.outerHeight() * 0.5;

        if (!isNaN(xx)) {
            this.hs.x += xx;
            this.lx += xx;
        }
        if (!isNaN(yy)) {
            this.hs.y += yy;
            this.ly += yy;
        }

//      if (Math.abs((this.hs.x + nw * 0.5) - (w * 0.5)) < 10) {
        if (Math.abs((this.lx + nw * 0.5) - (w * 0.5)) < 30) {
            this.hs.x = (w * 0.5) - (nw * 0.5);
        }

//      if (Math.abs((this.hs.y + nh * 0.5) - (h * 0.5)) < 10) {
        if (Math.abs((this.ly + nh * 0.5) - (h * 0.5)) < 30) {
            this.hs.y = (h * 0.5) - (nh * 0.5);
        }

        this.hs.update(true);

		this.drag.x = event.pageX;
		this.drag.y = event.pageY;

        this.updateRulers();

        this.hs.originX = this.x;// this.hs.hpos();
        this.hs.originY = this.y; //this.hs.vpos();

	}

    event.origin.preventDefault();
}

UIElementEdit.prototype.lock = function(b) {
    this.locked = b;
    if (b) {
        this.hs.node.css("pointer-events", "none");
    } else {
        this.hs.node.css("pointer-events", "all");
    }
}

UIElementEdit.prototype.toggleLock = function() {
    this.lock(!this.locked);
}
